/*
 *
 * Copyright 2021-2024, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */
import './WrcApp.css';
import React from 'react';
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { Button } from "@blueprintjs/core";
import { Card, Elevation } from "@blueprintjs/core";
import { Dialog } from "@blueprintjs/core";
import { Intent } from "@blueprintjs/core/lib/esm/index";
import { Toaster } from "@blueprintjs/core/lib/esm/index";
import { IconNames } from "@blueprintjs/icons";
import $ from "jquery";
import {WrcPageFooter} from "./components/WrcPageFooter.js";
import {WrcPageHeader} from "./components/WrcPageHeader.js";
import {WrcFind} from "./components/WrcFind.js"
import {WrcFormOpener} from "./components/WrcFormOpener.js"
import WrcListAndDetail from "./components/WrcListAndDetail.js"
import {WrcServer} from "./components/WrcServer.js";
import {WrcScheduleOpener} from "./components/WrcScheduleOpener.js";
import {WrcSpreadSheetOpener} from "./components/WrcSpreadSheetOpener.js";
import {WrcEmailOpener} from "./components/WrcEmailOpener.js";
import WrcStatusDashboard from "./components/WrcStatusDashboard.js";
import { WrcReports } from './components/WrcReports';
import { WrcDownload } from './components/WrcDownload';

export class WrcApp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            is_loaded: false,
            welcomeShown: true,
            loginOpen: false,
            canOutsideClickClose: false,
            site_name: ''
        };
        this.components = {WrcReports, WrcFind, WrcDownload, WrcFormOpener, WrcListAndDetail, WrcScheduleOpener, WrcSpreadSheetOpener, WrcEmailOpener, WrcStatusDashboard};
        this.component_list = [];
        this.refresh = this.refresh.bind(this);
        //this.configure_component = this.configure_component.bind(this);
    }

    componentDidMount() {
        WrcServer.post('check-environment', {}, (content) => this.checkEnvironment(content)
        );
    }

    render() {
        if (this.state.is_loaded) {
            let db_section = '';
            if (this.state.prompt_for_db === 1) {
                db_section = (
                    <React.Fragment>
                        <tr>
                            <th>DB name:</th>
                            <td><input id="db_name" name="db_name" type="text" autoFocus value={this.state.db_name} onChange={(e) => this.handleInputChange(e)} className='bp3-input' /></td>
                        </tr>
                        <tr>
                            <th>DB host:</th>
                            <td><input id="db_host" name="db_host" type="text" value={this.state.db_host} onChange={(e) => this.handleInputChange(e)} className='bp3-input' /></td>
                        </tr>
                    </React.Fragment>
                );
            }

            let login_view = '';
            let login_header = '';
            let login_footer = '';
            if (this.state.ad_groups === undefined) {
                login_view = (
                    <table>
                        <tbody style={{ lineHeight: 2.7 }}>
                            <tr>
                                <th>Username:</th>
                                <td><input id="username" name="username" type="text" autoFocus value={this.state.username} onChange={(e) => this.handleInputChange(e)} className='bp3-input' /></td>
                            </tr>
                            <tr>
                                <th>Password:</th>
                                <td><input id="password" name="password" type="password" value={this.state.password} onChange={(e) => this.handleInputChange(e)} className='bp3-input' /></td>
                            </tr>
                            {db_section}
                        </tbody>
                    </table>
                );
                if (this.state.login_header) {
                    login_header = parse(this.state.login_header);
                }
                login_footer = this.props.login_footer;
            } else {
                let adGroups = [...this.state.ad_groups].sort();
                let selectOptionList = adGroups.map(function (name, index) {
                    let adGroupPieces = name.split('-');
                    // Grab site and role pieces from AD group site-registry-role(-tier)
                    let display = adGroupPieces[0] + ' - ' + adGroupPieces[2];
                    return (
                        <option value={index}>{display}</option>
                    );
                });
                login_view = (
                    <div>
                        Role:
                        <select
                            name={'ad_group'}
                            value={this.state.ad_group}
                            onChange={(e) => this.handleInputChange(e)}>
                            <option value="-1">Select...</option>
                            {selectOptionList}
                        </select>
                        <input id="username" name="username" type="hidden" value={this.state.username} />
                        <input id="password" name="password" type="hidden" value={this.state.password} />
                    </div>
                );
            }

            let display_user;
            if (this.state.user) {
                display_user = this.state.user.first_name + ' ' + this.state.user.last_name;
            } else {
                display_user = this.state.username;
            }
            return (
                <div>
                    <div id="app-main">
                        <div id={'alertdiv'} />
                        {this.state.incompatible_browser &&
                            <Dialog
                                isOpen={true}
                                canOutsideClickClose={false}
                                canEscapeKeyClose={false}
                                isCloseButtonShown={false}
                                icon={IconNames.WARNING_SIGN}
                                title="Incompatible Browser Detected">
                                <p style={{ 'textAlign': 'center', 'padding': '10px' }}>
                                    The browser you are currently using is not compatible with this application.<br />
                                    Please re-open the application in another browser, such as Chrome or Firefox.<br />
                                    Thank you.
                                </p>
                            </Dialog>
                        }
                        {this.state.welcomeShown &&
                            <div id='app-login'>
                                <Card interactive={false} elevation={Elevation.TWO}>
                                    {this.props.welcome}<br />
                                    <Button icon={IconNames.LOG_IN} intent={Intent.PRIMARY} large={true} onClick={this.openLogin}>Login</Button>
                                </Card>
                            </div>}
                        <Dialog
                            isOpen={this.state.loginOpen}
                            onClose={this.closeLogin}
                            canOutsideClickClose={this.state.canOutsideClickClose}
                            icon={IconNames.LOG_IN}
                            title="Login">
                            <form id="login_form" onSubmit={(e) => this.submitLogin(e)}>
                                <input type="hidden" name="tiered_roles" value={this.props.tiered_roles} />
                                <div className="bp3-dialog-body">
                                    {login_header}
                                    {login_view}
                                </div>
                                <div className="bp3-dialog-footer">
                                    <div className="bp3-dialog-footer-actions" style={{ float: 'right' }}>
                                        <Button onClick={this.closeLogin} text="Cancel" type={'button'} />
                                        <Button intent={Intent.SUCCESS} text="OK" type={'submit'} />
                                    </div>
                                    {login_footer}
                                </div>
                            </form>
                        </Dialog>

                        {!this.state.welcomeShown &&
                            <div id='app-header-and-contents'>
                                <div id='app-header'>
                                    <WrcPageHeader
                                        project_name={this.props.project_name}
                                        title={this.props.title}
                                        username={display_user}
                                        site_name={this.state.site_name}
                                    />
                                </div>
                                <div id='app-contents'>
                                    <div id={'components'} />
                                    <div id={'form'} />
                                    <div id={'schedule'} />
                                    <div id={'spreadsheet'} />
                                    <div id={'email'} />
                                </div>
                            </div>}
                    </div>
                    <div className="app-footer">
                        <WrcPageFooter version={this.state.version} />
                    </div>
                </div>
            );
        }
        else {
            return (<div>Loading...</div>);
        }
    }

    checkEnvironment(content) {
        let incompatible_browser = this.checkBrowser();
        this.setState({
            incompatible_browser: incompatible_browser,
            prompt_for_db: content['NO_DB_NAME_SET'],
            version: '#' + content['DOCKER_VERSION'],
            registry: content['REGISTRY'],
            kap_host: content['KAP_HOST'],
            kap_usepass: content['KAP_USEPASS'] === "1",
            export_users: content['EXPORT_USERS'],
            login_header: content['LOGIN_HEADER'],
            is_loaded: true
        });
    }

    checkBrowser() {
        // code from MDN documentation on Window.navigator
        var sBrowser, sUsrAg = navigator.userAgent;
        // The order matters here, and this may report false positives for unlisted browsers.

        if (sUsrAg.indexOf("Firefox") > -1) {
            sBrowser = "Mozilla Firefox";
            // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
        } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
            sBrowser = "Samsung Internet";
            // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
        } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
            sBrowser = "Opera";
            // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
        } else if (sUsrAg.indexOf("Trident") > -1) {
            sBrowser = "Microsoft Internet Explorer";
            // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
        } else if (sUsrAg.indexOf("Edge") > -1) {
            sBrowser = "Microsoft Edge";
            // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
        } else if (sUsrAg.indexOf("Chrome") > -1) {
            sBrowser = "Google Chrome or Chromium";
            // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
        } else if (sUsrAg.indexOf("Safari") > -1) {
            sBrowser = "Apple Safari";
            // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
        } else {
            sBrowser = "unknown";
        }
        let incompatible_browser = false;
        if (/*sBrowser== 'Apple Safari' || */sBrowser == 'Microsoft Internet Explorer') {
            incompatible_browser = true;
        }
        return incompatible_browser;
    }

    parentSetState = (newState) => {
        this.setState(newState)
    }

    parentGetState = () => {
        return this.state
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    refresh() {
        let component_nodes = document.querySelectorAll('#components')[0]['children']
        if (component_nodes.length > 0) {
            for (let i=0; i<component_nodes.length; i++) {
                ReactDOM.unmountComponentAtNode(document.querySelector('#components'))
            }
        }
        ReactDOM.render(
            this.component_list.map(function (component, index) {
                var props = component['props'];
                props['refresh'] = this.refresh;
                props['app_layout'] = this.props.app_layout ? this.props.app_layout : {
                    main_layout: "vertical",
                    ld_child_grandchild_layout: "vertical"
                };
                props['component_alignment'] = this.props.component_alignment ? this.props.component_alignment : 'center';
                props['component_index'] = index;
                props['user'] = 'user' in this.state ? this.state.user : {};
                props['program_role'] = this.state.program_role;

                // used for determining permissions to downloadables
                props['username'] = this.state.username;
                props['ad_groups'] = this.state.ad_groups;

                props['readonly'] = this.state.readonly;
                props['registry'] = this.state.registry;

                // allows passing of state via callback as well as vertical movement of data/persistence of data in reloads
                props['parentSetState'] = this.parentSetState;
                props['parentGetState'] = this.parentGetState;

                return (
                    React.createElement(this.components[component['name']], props)
                );
            }.bind(this)),
            document.querySelector('#components'));
    }

    // User is read-only if they do not have any user_roles ending in _user
    isUserReadOnly(user_roles) {
        return !user_roles.some(e => /_user$/.test(e));
    }

    closeLogin = () => {
        this.setState({ loginOpen: false });
    };

    openLogin = () => {
        this.setState({
            loginOpen: true,
            username: '',
            password: '',
            ad_group: undefined,
            ad_groups: undefined,
        });
    };

    submitLogin = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.state.username === '') {
            Toaster.create().show({ message: 'You must enter a username.', intent: Intent.WARNING });
            return false;
        }
        if (this.state.password === '') {
            Toaster.create().show({ message: 'You must enter a password.', intent: Intent.WARNING });
            return false;
        }
        if (this.state.ad_group === '-1') {
            Toaster.create().show({ message: 'You must choose a role.', intent: Intent.WARNING });
            return false;
        }

        if (this.state.prompt_for_db === 1) {
            if (this.state.db_name === '') {
                Toaster.create().show({ message: 'You must enter a DB name.', intent: Intent.WARNING });
                return false;
            }
            if (this.state.db_host === '') {
                Toaster.create().show({ message: 'You must enter DB host.', intent: Intent.WARNING });
                return false;
            }
        }

        $.post("./registry-common/ajax/login.php", $("#login_form").serialize(), function (data) {
            let response = '';
            try {
                response = JSON.parse(data);
                const record = response['content'];
                if (response['status'] === 1) {
                    if (record['ad_groups'] === undefined) {
                        let userReadOnly = this.isUserReadOnly(record['user_roles']);
                        WrcServer.post('get-user-kap-info', {}, function (userKAPInfo) {
                            this.setState({
                                welcomeShown: false,
                                loginOpen: false,
                                site_name: this.props.site_name ? this.props.site_name : record['site_name'],
                                user: userKAPInfo,
                                readonly: userReadOnly,
                                program_role: record['program'] !== null && record['program'] !== '',
                                registration_form: { form_name: "", elements: [] }
                            });
                            this.component_list = record['component_list'];
                            // this.component_list = record['component_list'].filter((component, index) => component.name !== 'WrcAccrualReports');
                            this.refresh();
                        }.bind(this));
                    }
                    else {
                        this.setState({ ad_groups: record['ad_groups'], ad_group: '-1' });
                    }
                }
                else {
                    Toaster.create().show({ message: record, intent: Intent.WARNING });
                }
            } catch (err) {
                Toaster.create().show({ message: data, intent: Intent.DANGER });
            }
            return false;
        }.bind(this)).fail(function (data) {
            Toaster.create().show({ message: data, intent: Intent.DANGER });
        });

        return false;
    };
}

WrcApp.propTypes = {
    app_layout: PropTypes.object,
    component_alignment: PropTypes.string,
    login_footer: PropTypes.string,
    project_name: PropTypes.string.isRequired,
    site_name: PropTypes.string,
    tiered_roles: PropTypes.bool,
    title: PropTypes.string.isRequired,
    welcome: PropTypes.element.isRequired,
};

WrcApp.defaultProps = {
    tiered_roles: false
};
